import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router,  ActivatedRoute, RouterModule  } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserDto } from '@models/user-dto';
import { UserClassesService } from '@services/user-classes.service';
import { UserService } from '@services/user.service';
import { CustomValidators } from '@shared/validators/custom.validators';

declare function getToday(): any;

@Component({
  selector: 'admin-panel-nav',
  templateUrl: './admin-panel-nav.component.html',
  styleUrls: ['./admin-panel-nav.component.css']  //'../../../assets/bootstrap/css/bootstrap.min.css'
})
export class AdminNavComponent implements OnInit {
  model: any = {};
  addToClassForm: FormGroup;
  processing: boolean;
  email: string;
  token: string;

  constructor(private fb: FormBuilder, private router: Router,
    private userService: UserService, public authService: AuthService, private alertify: AlertifyService,private actRoute: ActivatedRoute,
    private userClassesService: UserClassesService) { }

    /*
  ngOnInit() {
    this.createLoginForm();

    this.processing = true;
    if (this.authService.loggedIn()) {
      this.router.navigate(['/home']); 
    }

  }
  */
  ngOnInit() {

  }


  //Assigns values to the form
  createAddToClassForm() {
    this.addToClassForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
      listofnames: ['', [Validators.required]]
    });
  }

  /*
  resetUserPassword() {
    this.model = Object.assign({}, this.changePasswordForm.value);

    this.authService.changePassword(this.model).subscribe(next => {
      this.alertify.success('Your password had been changed successfully.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }
  */
  addToClass() {
    this.model = Object.assign({}, this.addToClassForm.value);
  
    this.authService.addToClass(this.model).subscribe(next => {
      this.alertify.success('Users have been added to the class.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }

  register() {
    this.router.navigate(['/register']);
  }

}
